const PREFIX = 'uf/appservices';

export const APP_ADD_MESSAGE = 'uf/appservices/APP_ADD_MESSAGE';
export const APP_REMOVE_MESSAGE = `${PREFIX}/APP_REMOVE_MESSAGE`;
